<template>
  <b-form @submit.prevent="onSubmit">
    <b-card-header class=" v2_box_teal_header v2_color_black">
      <b-row>
        <b-col sm="12" md="6" class="d-flex align-items-center">
          <span class="v2_color_white v2_font_size_24 v2_font_weight_semibold">
            My Profile
          </span>
        </b-col>
        <b-col sm="12" md="6" class="float-md-right text-md-right mt-2 mt-md-0">
          <b-button type="submit" variant="v2_primary_white" class="mr-2">
            <template v-if="!saveLoading">Save</template>
            <template v-else>
              <b-spinner small/>
              <span class="ml-1">Saving...</span>
            </template>
          </b-button>
          <b-button variant="v2_white" @click="cancel">
            Cancel
          </b-button>
        </b-col>
      </b-row>
    </b-card-header>
    <b-card-body>
      <b-row class="mt-3 mt-md-0 my-2">
        <b-col xl="6" lg="6" md="6" sm="12">
          <span class="v2_color_teal v2_font_weight_semibold">
            Profile Type:
          </span>
          <span>{{ profileType }}</span>
        </b-col>
      </b-row>
      <b-row class="mt-3 mt-md-0 my-2">
        <b-col xl="6" lg="6" md="6" sm="12">
          <span class="v2_color_teal v2_font_weight_semibold">
            Email:
          </span>
          <span>{{ user.email }}</span>
        </b-col>
      </b-row>
      <b-row>
        <b-col xl="6" lg="6" md="6" sm="12">
          <b-form-group
              :invalid-feedback="lastNameInvalidFeedback"
              :state="validateState('last_name')"
              label="Last name"
              label-class="v2_color_teal v2_font_weight_semibold"
          >
            <b-form-input
                type="text"
                v-model="$v.last_name.$model"
                :state="validateState('last_name')"
                class="p-3 phairify-border-grey height_auto v2_font_size_18 v2_color_black"
            />
          </b-form-group>
          <b-form-group
              :invalid-feedback="firstNameInvalidFeedback"
              :state="validateState('first_name')"
              label="First name"
              label-class="v2_color_teal v2_font_weight_semibold"
          >
            <b-form-input
                type="text"
                v-model="$v.first_name.$model"
                :state="validateState('first_name')"
                class="p-3 phairify-border-grey height_auto v2_font_size_18 v2_color_black"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-card-body>
  </b-form>
</template>

<script>
import {alphaSpaceValidator} from '@/helpers/customValidators';
import {validationMixin} from 'vuelidate';

export default {
  name: 'UserProfileAdminForm',
  mixins: [validationMixin],
  props: {
    saveLoading: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    const user = this.$store.state.user || {};
    return {
      first_name: user.first_name || null,
      last_name: user.last_name || null,
    };
  },
  validations: function () {
    return {
      last_name: {
        alphaSpaceValidator,
      },
      first_name: {
        alphaSpaceValidator,
      },
    };
  },
  computed: {
    user: function () {
      return this.$store.state.user ? this.$store.state.user : {};
    },
    lastNameInvalidFeedback: function () {
      return !this.$v.last_name.alphaSpaceValidator
          ? 'Only alpha characters are allowed'
          : '';
    },
    firstNameInvalidFeedback: function () {
      return !this.$v.first_name.alphaSpaceValidator
          ? 'Only alpha characters are allowed'
          : '';
    },
    profileType: function () {
      return this.$store.getters.userIsGMAdmin
          ? 'Phairify Admin'
          : 'Society Admin';
    },
  },
  methods: {
    cancel: function () {
      this.$emit('profileFormCancel');
    },
    validateState: function (name) {
      const {$dirty, $error} = this.$v[name];
      return $dirty ? !$error : null;
    },
    onSubmit: async function () {
      this.$v.$touch();
      if (this.$v.$anyError) {
        return;
      }

      let updatedUser = {
        first_name: this.first_name.trim(),
        last_name: this.last_name.trim(),
      };

      this.$emit('profileFormSubmit', updatedUser);
    },
  },
  watch: {
    user: function () {
      this.first_name = this.user.first_name;
      this.last_name = this.user.last_name;
    },
  },
};
</script>

<style scoped></style>
